import { render, staticRenderFns } from "./OrderPriceDetails.vue?vue&type=template&id=0b994741&scoped=true&"
import script from "./OrderPriceDetails.vue?vue&type=script&lang=js&"
export * from "./OrderPriceDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrderPriceDetails.vue?vue&type=style&index=0&id=0b994741&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b994741",
  null
  
)

export default component.exports